module.exports = __webpack_public_path__ + "img/in-routing.62c82dcd.svg";